import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";

export const SectionSix = () => {
  return (
    <>
      <Container fluid className="bg-tour">
        <Container>
          <Row className="align-items-center">
            <Col lg="4">
              <div className="py-7">
                <h2 className="text-3xl text-white font-extrabold">
                  Travel & Tour
                </h2>
                <p className="text-lg text-white font-semibold">
                  Life is a journey, enjoy the trip. Aim for the sky, but move
                  slowly, enjoying every step along the way. It is all those
                  little steps that make the journey complete. The journey is a
                  reward.
                </p>
                <h2 className="text-2xl text-white mt-7">COMING SOON</h2>
              </div>
            </Col>
            <Col lg="8">
              <div className="py-2">
                <Image src={require("../../assets/tourTravel.png")} />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};
